import { modals } from '@mantine/modals';
import ImageView from '~/components/browser/implementations/ImageView';
import { api } from '~/trpc-extra/api';
import { Text } from '@mantine/core';

export function useViewOperationImage() {
  const openOperationImage = (operationId: string) => {
    modals.open({
      centered: true,
      title: <OperationImageModalDescription operationId={operationId} />,
      children: <ImageView operationId={operationId} />,
      size: '60%',
      zIndex: 310,
    });
  };

  return { openOperationImage };
}

function OperationImageModalDescription({ operationId }: { operationId: string }) {
  const { data: description, isLoading } = api.operation.getDescription.useQuery({ operationId });
  return (
    <div className="flex flex-col">
      <Text>Action{isLoading || !description ? ' Screenshot' : `: ${description}`}</Text>
      <Text
        size="sm"
        c="dimmed"
      >
        Note: Action screenshots were generated from previous preview/run and may not be the latest state of the page.
      </Text>
    </div>
  );
}
